export default "__VITE_ASSET__C2aSpg_1__"